var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.65,
    cy: 60.55,
    r: 22.45,
    fill: "#97CF26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.45,
    cy: 60.55,
    r: 10.45,
    fill: "#A169F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.65,
    cy: 18.35,
    r: 14.45,
    fill: "#FF6163"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.45,
    cy: 18.35,
    r: 18.45,
    fill: "#0AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvito);
export default __webpack_public_path__ + "static/media/avito.b28ea57faec64818243d10b3ec3333ee.svg";
export { ForwardRef as ReactComponent };